<mat-card class="cardmetrica">
    <mat-card-header>
        <div mat-card-avatar class="example-header-image">
            <a type="button" (click)="cargarResumen()">
                <mat-icon>refresh</mat-icon>
            </a>
        </div>
        <mat-card-title>{{textoGrafica}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
        <vex-chart [options]="options" [series]="series"></vex-chart>
    </mat-card-content>
</mat-card>